module.exports = __webpack_public_path__ + "media/18.2f564909.wav";